export function wrapWithRetryHandling<TReturn>(
    method: () => Promise<TReturn>,
    maxRetries: number,
    errorHandler: (error) => void = () => {}
): Promise<TReturn> {
    const retry = async (attempt = 1): Promise<TReturn> => {
        return await method().catch((error) => {
            if (attempt >= maxRetries) {
                throw error;
            }
            errorHandler(error);

            // Use an increasing delay to prevent flooding the
            // server with requests in case of a short downtime.
            const delay = 2000 + 1000 * Math.pow(2, attempt);

            return new Promise((resolve) => setTimeout(() => resolve(retry(attempt + 1)), delay));
        });
    };

    return retry();
}
